module.exports = __webpack_public_path__ + "img/abilities.984fa2fb.svg";